import { makeStyles } from '@rbx/ui';

const useAppMainNavbarStyles = makeStyles()((theme) => ({
  actionsWithBreadcrumbs: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('Medium')]: {
      marginTop: theme.spacing(2),
      marginLeft: 0,
      '& .MuiButtonBase-root': {
        paddingLeft: 0,
        paddingRight: 0,
        marginRight: theme.spacing(2),
      },
    },
  },
}));

export default useAppMainNavbarStyles;
